import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import store from './store'
import vuetify from './plugins/vuetify';
import Cookies from 'js-cookie'
import axios from 'axios'

import VueEventBus from './plugins/eventbus';

Vue.use(VueEventBus);

Vue.use(Cookies);

export const getCookie = (name) => {
  let cookie = " " + document.cookie;
  let search = " " + name + "=";
  let setStr = null;
  let offset = 0;
  let end = 0;
  if (cookie.length > 0) {
    offset = cookie.indexOf(search);
    if (offset != -1) {
      offset += search.length;
      end = cookie.indexOf(";", offset)
      if (end == -1) {
        end = cookie.length;
      }
      setStr = unescape(cookie.substring(offset, end));
    }
  }
  return(setStr);
}

Vue.prototype.$variables = Vue.observable({
  appHeight: window.innerHeight,
  appWidth: window.innerWidth,
  loaded: 1,
  autoScroll: (getCookie('scroll') == 'true' ? true : false)
});


export const setLoad = (flag) => {

  Vue.prototype.$variables.loaded = flag;
};

Vue.config.devtools = true;
Vue.config.productionTip = false;
axios.defaults.baseURL = process.env.VUE_APP_URL;



import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

Vue.filter('numFormat', (value, currency = '') => {

  let chunks = ['', currency, parseFloat(value)];

  if (!chunks[2]) { chunks[2] = 0; }

  if (chunks[2] < 0) {
    chunks[0] = '-';
    chunks[2] = Math.abs(chunks[2]);
  }

  chunks[2] = numFormat(numeral)(chunks[2]);

  return chunks.join('');
});


Vue.filter('dayFormat', value => parseFloat(value).toFixed(1));

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  beforeMount() {
    const auth_token = Cookies.get('user-auth_token');
    if (auth_token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${auth_token}`;
    }
  },
}).$mount('#app');


